export default "__VITE_ASSET__Bpf2GDHv__"